import { Component, OnInit, Input } from '@angular/core';
import { PersonAddEditComponent } from './person-add-edit/person-add-edit.component';

@Component({
  selector: 'app-nominated-persons',
  templateUrl: './nominated-persons.component.html',
  styleUrls: ['./nominated-persons.component.scss']
})
export class NominatedPersonsComponent implements OnInit {

  @Input() object: Object;
  @Input() summaryOnly: boolean = false;
  public key: string;
  public extraData: Object;

  constructor() { }

  ngOnInit(): void {

    this.key = 'nominated-person';
    this.extraData = {
      heading: this.object['title']['rendered'],
      component: PersonAddEditComponent,
      showSummaryOnly: this.showSummaryOnly(),
      options: {
        class: 'modal-lg'
      },
      section: {
        key: 'nominated-person',
        title: 'Nominated Person(s)',
        type: 'children',
        childType: 'nominated-person',
        plural: 'nominated persons',
        singular: 'Nominated Person',
        min: 0,
        max: 0,
      },
    }

  }

  showSummaryOnly() {

    if( typeof( this.object ) === 'undefined' ) {
      return true;
    }

    return this.summaryOnly;

  }

}
